import React, { Component } from "react";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { Provider, connect } from "react-redux";
import reducer from "../../reducers/top/follow_circle_list";
import saga from "../../sagas/top/follow_circle_list";
import actionCreators from "../../actions/top/follow_circle_list";

import Loader from "../../components/loader";
import MyCircle from "../../components/top/my_circle";

const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class FollowCircleList extends Component {
  UNSAFE_componentWillMount() {
    store.dispatch(actionCreators.top.followcircles.set());
  }
  render() {
    return (
      <Provider store={store}>
        <Root />
      </Provider>
    );
  }
}

const TmpRoot = ({ state }) => {
  if (state.loading) {
    return <Loader isActive={state.loading} />;
  }
  if (state.followCircles.length == 0) return <div />;
  const circles = state.followCircles.map(function(circle) {
    return (
      <MyCircle circle={circle.circle} isMyCircleUri={false} key={circle.id} />
    );
  });
  return (
    <div>
      <article className="timeline-box mb10">
        <h2 className="left">
          <i className="fas fa-bookmark icon_blue" aria-hidden="true" />&nbsp;フォローサークル
        </h2>
        <div className="touch-wrap">
          <div className="touch">{circles}</div>
        </div>
      </article>
    </div>
  );
};

const mapStateToProps = (state) => ({
  state,
});

const Root = connect(mapStateToProps)(TmpRoot);
